module.exports = __webpack_public_path__ + "static/sakesZoom-e7f07cb9098fe34be94e4ba31860824d.jpg";